import { cn } from "../../../Pages/Main/Retailer/Invoice/invoiceUtils";

export function Badge({ tone = "slate", children }) {
  const tones = {
    green: "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200/70",
    amber: "bg-amber-50 text-amber-700 ring-1 ring-amber-200/70",
    red: "bg-rose-50 text-rose-700 ring-1 ring-rose-200/70",
    blue: "bg-blue-50 text-blue-700 ring-1 ring-blue-200/70",
    slate: "bg-slate-50 text-slate-700 ring-1 ring-slate-200/70",
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold text-nowrap",
        tones[tone] || tones.slate
      )}
    >
      {children}
    </span>
  );
}